// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalWrapper_wrapper__uhxyJ","fadeIn":"ModalWrapper_fadeIn__AFwBJ","animate":"ModalWrapper_animate__2YDOt"};